import React, { Suspense, useEffect } from "react"

import { Routes, Route, BrowserRouter as Router } from "react-router-dom"
import { ReactNotifications } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';

// Import Routes all
import { protectedRoutes, publicRoutes } from "./routes"

// Import all middleware
import Authmiddleware from "~/routes/route"

// layouts Format
import VerticalLayout from "~/components/VerticalLayout/"
import NonAuthLayout from "~/components/NonAuthLayout"
import NotFound from "~/pages/Error/NotFound"

// Import scss
import "./assets/scss/theme.scss"
import ActivityStatusMonitor from '~/components/Shared/ActivityStatusMonitor';
import { initializeTagManager } from '~/hooks/gtm';
import HelpSidebar from '~/components/VerticalLayout/HelpSidebar';
import Preloader from '~/components/Shared/Preloader';

const App = () => {

  useEffect(() => {
    initializeTagManager();
  }, [])

  return (
    <ActivityStatusMonitor>
      <ReactNotifications />
      <HelpSidebar />
      <Router>
        <Suspense fallback={<Preloader />}>
          <Routes>
            {publicRoutes.map((route, idx) => <Route key={idx} path={route.path} element={<Authmiddleware
              layout={NonAuthLayout}
              component={route.component}
              componentProps={route.props}
              isProtected={false}
              key={idx}
              isStrict={route.isStrict}
            />} />)}
            {protectedRoutes.map((route, idx) => <Route key={idx} path={route.path} element={<Authmiddleware
              layout={route.layout || VerticalLayout}
              component={route.component}
              componentProps={route.props}
              key={idx}
              isProtected={true}
            />} />)}
            <Route element={<NotFound title="Page not found" />} />
          </Routes>
        </Suspense>
      </Router>
    </ActivityStatusMonitor>
  )
}

export default App
